import { ChangeDetectionStrategy, Component, EventEmitter, HostBinding, Input, Output } from '@angular/core';

const ERROR_CLASS = 'error__container';

@Component({
  selector: 'app-error',
  templateUrl: './error.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ErrorComponent {
  @Input() public errorDescription = '';
  /** Whether to show the title or not */
  @Input() showTitle = true;
  /** Used to set the custom class for error component. */
  @Input()
  public errorClass = '';

  @Output() public retry = new EventEmitter<boolean>();
  @Input() public isRetrying: boolean;

  /** Will bind the default class and custom class to the component. */
  @HostBinding('class')
  public get hostClass(): string {
    return `${ERROR_CLASS} ${this.errorClass}`;
  }

  public tryAgain() {
    this.retry.emit(true);
  }
}
